import { TableHelp } from "../../help/table_help";
import * as TexasProto from "../../../../net/proto/proto_texasholdem_game";
import { Define } from "../../data/const_define";
import ModuleManager from "../../../../../../framework/core/module_manager";;
import { TableData } from "../../data/table_data";
import { SeatEntityBase } from "../seat/seat_entity_base";
import TexasSound from "../../../texas_sound";
import SceneManager from '../../../../../../manager/scene_manager';
import { TableEntityBase } from "./table_entity_base";
import ModelData from "../../../../../public/model_data";
import LanguageManager from "../../../../../../manager/language_manager";
import UserDataManager, { IUserCurrencyData } from "../../../../../../manager/user_manager";
import Utility from "../../../../../../utility/utility";
import EventManager from "../../../../../../manager/event_manager";
//ui公共层
export class TableEntityViewModel extends TableEntityBase{

    private isCreate = false;//游戏是否构建完成

    onViewInited(){
        super.onViewInited();
        //添加加筹码
        this.viewBase.addBet.on('click',this.addBetCallBack,this);
        this.viewBase.heguan.on('click',this.addBetCallBack,this);
        this.dealerState(false)
    }

    onCreate(){}

    //游戏初始化执行
    initGame(protoData:TexasProto.Texas.GameInfo){
        if (this.isCreate) {
            return;
        }
        this.isCreate = true;
        super.initGame(protoData);
        this.viewBase.setSeatNumb(this.tableSeatNumb);//设置座位数
        this.createSeatClickNode();
        this.createSeatEntity();
        this.registerStateFunc();
    }

    //注册操作状态
    registerStateFunc(){
        //发牌状态
        this.setStateFunc(Define.NextAction.DealCards,this.dealCardsToPlayer);
        this.setStateFunc(Define.NextAction.Player_Actions,this.playerDoAction);
        this.setStateFunc(Define.NextAction.CommonCard,this.showCommonPokers);
        this.setStateFunc(Define.NextAction.End,this.gameOverAction);
        this.setStateFunc(Define.NextAction.GuiChi,this.guiChiAction);
        this.setStateFunc(Define.NextAction.GameOver,this.gameOverClear);
        this.setStateFunc(Define.NextAction.sidePotEnd,this.sidePotAction)
        this.setStateFunc(Define.NextAction.No_opening,this.noOpenGame);
    }

    createSeatEntity(){
        for (let i = 0; i < this.tableSeatNumb; i++) {
            let seatBase = new SeatEntityBase();
            this.seatEntityBase[i] = seatBase;
            seatBase.Init(this.viewBase.seatRoot,this);
        }
    }

    private seatID = 0
    clickSeatBtn(btn:cc.Button){
        this.seatID = this.getSeatID(parseInt(btn.name));
        let playerData = ModelData.instance.roomInfo.PlayRuleData
        if (this.selfServerSeatID == 0) {//已经站起了
            let self = this;
            let func = (data:number,isCharge:boolean)=>{
                self.ReqPlayerAction(Define.SeatAction.Seat,self.seatID,data,isCharge);
            }
            let lockGold = this.getLockGold();
            let data = {
                lockGold:lockGold,
                min:this.commonData.min_join_coin,
                max:this.commonData.max_join_coin,
                bigBlind:playerData.game_BigBlind || 0,
                callFunc:func,
            }
            ModuleManager.instance.showModuleName('TexasChips',data);
        }
    }

    addBetCallBack(btn:cc.Node = null,endTips:boolean=false){//游戏中补充筹码
        Utility.playButtonSound();
        let self = this
        if (this.commonData) {
            if (this.commonData.accountbalance <= 0) {
                ModuleManager.instance.toastKey('server_error_-41');
            }else{
                self.openTexasChips(endTips);
            }
        }
    }

    private openTexasChips(endTips:boolean=false){
        let self = this;
        let playerData = ModelData.instance.roomInfo.PlayRuleData
        let func = (data:number,isChange:boolean)=>{
            let pData = this.getPlayerSeatData();
            if (pData && pData.chips == data) {//补充的与余额相等无需发送协议
                
            }else{
                self.modeBase.send_ReCharge_request(data,isChange);
            }
        }
        let endCallFunc = ()=>{
            if (endTips) {
                ModuleManager.instance.toastKey(Define.OpTips[7]);
            }
        }
        let lockGold = this.getLockGold();
        let data = {
            lockGold:lockGold,
            min:this.commonData.min_join_coin,
            max:this.commonData.max_join_coin,
            bigBlind:playerData.game_BigBlind || 0,
            callFunc:func,
            colseCallBack:endCallFunc,
            account_balance:this.commonData.accountbalance,
        }
        ModuleManager.instance.showModuleName('TexasChips',data);
    }

    private getLockGold(){
        let lockGold = 0;
        //let seatData = this.getPlayerSeatData();
        // if (seatData) {
        //     if (this.commonData.coinStatus == 2) {//解锁玩家金币
        //             lockGold = 0;
        //     }else if(this.commonData.coinStatus == 1){//锁定玩家金币
        //         lockGold = seatData.chips;
        //     }
        // }
        return lockGold;
    }

    //创建可点击的座位
    createSeatClickNode(){
        //创建座位
        this.seatNode = this.seatNode || [];
        for (let i = 0; i < this.tableSeatNumb; i++) {
            let seatNode = this.viewBase.addSeat(i);
            this.seatNode[i] = seatNode;
            seatNode.active = false;
        }
    }

    onRevGameInfo(protoData:TexasProto.Texas.GameInfo){
        super.onRevGameInfo(protoData);

        this.initGame(protoData);

        this.refreshPlayerSeatUI();

        this.refreshTableUI(protoData);
    }

    oRechargeReply(data:TexasProto.Texas.IRechargeReply){
        
        let seatData = this.getPlayerSeatData();
        if (seatData) {
            let oldChips = seatData.chips;
            super.oRechargeReply(data);
            //如果未开局,直接补充,更新
            if (!data.isPlaying
                && data.ok) {
                let entity = this.getEntityServerID(this.selfServerSeatID);
                if (entity) {
                    if (Math.abs(oldChips - seatData.chips) >= 0.1) {
                        entity.updateEntityChips(oldChips);
                    }
                }
            }
        }
    }

    showTime(protoData:TexasProto.Texas.GameStart){
         this.gameOverCountdown(protoData.nextRoundStartTime);
    }

    private refreshPlayerSeatUI(){
        this.seatData.forEach((data:TableData.SeatPlayerData)=>{
            if (data) {
                if (data.state == Define.PlayerState.Look_1) {
                    this.playerStandUpSeatID(data.player_pos);
                }else{
                    this.playerSitDownSeatID(data.player_pos);
                }
            }
        })

        this.refreshSeatVisible();
    }

    private refreshTableUI(protoData:TexasProto.Texas.GameInfo){

        let playerData = ModelData.instance.roomInfo.PlayRuleData

        let preBet = playerData.game_BetPre;

        let blindstr = LanguageManager.t(Define.OpTips[1]) + (playerData.game_SmallBlind) + '/' + (playerData.game_BigBlind);

        if (!preBet) {//没有前注
            this.viewBase.blinds = blindstr
        }else{
            this.viewBase.blinds = LanguageManager.t('dz_qianzhu') + preBet + '  ' + blindstr
        }

        let state = protoData.nextAction.state;
        this.boardData.gameState = state;
        this.gameInfoReconnect(protoData);
        if (state == 11
            || state == 7) {//重连不处理结算
            return;
        }
        let func = this.stateFunc[state];
        if (func) {
            func(protoData.nextAction,protoData)
        }else{
            cc.log('未处理的状态',state);
        }
    }

    //处理重连
    private gameInfoReconnect(info:TexasProto.Texas.GameInfo){

        //显示公共牌
        if (info.publicCards != undefined) {
            this.commonPokers.showImmediately(info.publicCards);
        }
        //更新总池
        this.showAddBet(info);
        this.gameOverCountdown(info.nextRoundStartTime);
        if (this.boardData.gameState != Define.NextAction.DealCards) {
            this.refreshPot(info.pot);//更新
        }

        if (info.sidePots.length > 0) {
            let sidePots = this.getListSidePot(info);
            if (sidePots.length > 0) {
                this.viewBase.updateSidePot(sidePots);
            }
        }
        //显示手牌,牌型
        if (this.boardData.gameState != Define.NextAction.DealCards
            && this.boardData.gameState != Define.NextAction.GameOver) {//不是发牌状态
            let seatEntity = this.inGameSeatEntity();
            for (let seat of seatEntity) {
                seat.showHandRapid(true);
            }
            this.showMaxCardPattern(info);
        }
    }

    //获取剩余的边池
    private getListSidePot(info:TexasProto.Texas.GameInfo):TexasProto.Texas.ISidePot[]{
        let sidepots = info.sidePots.concat([]);
        if (this.boardData.gameState == Define.NextAction.sidePotEnd) {
            if (info.nextAction.sidePotNum != 0) {
                let sidePotIndex = info.nextAction.sidePotNum-1;//当前是第几个
                sidepots = [];
                for (let index = sidePotIndex; index < info.sidePots.length; index++) {
                    sidepots.push(info.sidePots[index]);
                }
            }
        }
        return sidepots;
    }

    private showAddBet(protoData:TexasProto.Texas.GameInfo){
        if (protoData && protoData.needRecharge) {
            this.addBetCallBack();
        }
    }

    //翻公共牌
    private showCommonPokers(action:TexasProto.Texas.INextAction){
        this.commonPokers.enQueue(this.boardData.cards,()=>{
            this.updateMyMaxCardType(action.maxCardInfo);//更新我方最大牌型
            cc.log('---翻牌完成')
        });
        cc.log('-----------------翻公共牌');
    }

    //牌局结束
    private gameOverClear(action:TexasProto.Texas.INextAction){
        cc.log('-----------------牌局结束');
        this.boardData.gameState = Define.NextAction.No_opening;//更改游戏状态
        this.commonData.isShowHand = true;
        this.stopAllAction()
        super.reset();
        this.viewBase.reset();
        this.emit(Define.refreshUI,null);
        //重置座位
        if (this.seatEntityBase) {
            for (let seatEntity of this.seatEntityBase) {
                seatEntity.gameOverClear();
            } 
        }
        this.refreshSitState();//更新座位状态
        this.refreshPlayerSeatUI();
        this.gameOverCountdown(action.gameEndInfo.nextRoundStartTime);
    }

    //为开局
    private noOpenGame(){
        this.dealerState(false)
        this.emit(Define.refreshUI,null);
        cc.log('-----------------未开局');
    }

    //边池处理
    private sidePotAction(action:TexasProto.Texas.INextAction){
        //亮牌
        if (this.commonData.isShowHand) {
            this.emit(Define.refreshUI,null);
            this.showVictory(action);
            this.lightYourHands(action.gameSettlement.players);
            this.commonData.isShowHand = false;
        }
        this.dealerNode.stopAllActions();
        this.commonData.sidePotIndex = 0;
        TableHelp.delay(this.dealerNode,()=>{
            this.startHandleSidePots(action.sidePots,action.gameSettlement);
            cc.log('-----------------边池处理');
        },Define.lightHandsTime)
    }

    private startHandleSidePots(sidepots:TexasProto.Texas.ISidePot[],settlement:TexasProto.Texas.IGameSettlement){
        if (!sidepots) {
            return;
        }

        let count = sidepots.length == 0 ? 1:sidepots.length;
        //计时优化
        TableHelp.repeatTimesAction(this.dealerNode,1.0,count,()=>{
            this.handleSidePotAction(sidepots[this.commonData.sidePotIndex],settlement)
            if (sidepots.length > 0) {
                if (this.commonData.sidePotIndex >= sidepots.length) {
                    this.dealerNode.stopAllActions();
                }
            }
        })
    }

    //显示胜利
    private showVictory(action:TexasProto.Texas.INextAction){
        let players = action.gameSettlement;
        if (players) {
            for (let player of players.players) {
                let isWinner = player.winLoseBet > 0;//和局
                let entity = this.getEntityByPlayerID(player.playerId);
                if (entity) {
                    entity.showMaxCardNode(false);
                    entity.isWinner = isWinner;
                    if (isWinner) {
                        let type = player.maxCardInfo ? player.maxCardInfo.maxCardsType:null;
                        //延迟400ms显示胜利动画
                        entity.delayShowWinAnim(type,()=>{
                            if (this.isRole(player.playerId)) {
                                let mySelf = this.getEntityServerID(this.selfServerSeatID);
                                if (mySelf && mySelf.isPlayingGame()
                                && !mySelf.isFold()) {
                                    if (mySelf.isWinner) {
                                        TexasSound.bipaiwin();
                                    }else{
                                        TexasSound.bipailose();
                                    }
                                }
                            }
                        });
                    }
                }
            }

            let mySelf = this.getEntityServerID(this.selfServerSeatID);
            if (mySelf && mySelf.isPlayingGame()) {
                if (!mySelf.isWinner && !mySelf.isFold()) {
                    TexasSound.bipailose();
                }
            }
   
        }
    }

    userMsg(protoData:TexasProto.Texas.UserMsg){
        super.userMsg(protoData);
    }

    //归池
    private guiChiAction(action:TexasProto.Texas.INextAction){
        
        for (let st of this.seatEntityBase) {
            st.setBetState(false)//隐藏
            st.guiChi(this.viewBase.checkBetNode);
        }
        this.emit(Define.refreshUI,null);//我弃牌
        this.updateSidePot(action.sidePots);
    }

    //结算
    protected gameOverAction(action:TexasProto.Texas.INextAction){
        this.updateMyMaxCardType(action.maxCardInfo);//更新我方最大牌型
        this.gameOver(action.gameSettlement);//翻共牌结算
        TableHelp.delay(this.dealerNode,()=>{
            if (action.gameSettlement.endByFold) {//弃牌结算
                this.foldEndAction(action.gameSettlement);
            }else{
                this.sidePotAction(action)
                //this.handleSidePotAction(null,action.gameSettlement)
            }
            cc.log('-----------------边池处理');
        },0.7)
        cc.log('-----------------结算');
        let myself = this.getEntityServerID(this.selfServerSeatID);
        EventManager.instance.dispatch('Game_Table_Settlement',myself.effectNode);
        //this.sidePotAction(action)
    }

    //处理弃牌结算动作
    protected foldEndAction(settlment:TexasProto.Texas.IGameSettlement){
        cc.log('------------->>>>>>>>>>>弃牌结算')
        let winners = this.maxPlayerInBigSide(settlment,true)
        //全部
        if (winners.length == 0) {
            return;
        }

        let winnerPlayer = winners[0];
        this.doSidePotAction(winners,settlment,0);

        let winner = this.getEntityByPlayerID(winnerPlayer.id);
        if (!winner) {
            return;
        }

        //所有边池归池
        //2.飞筹码,飞往多个
        let sidePool = this.viewBase.sidePool;

        let pools = sidePool.getPools();

        //

        if (winnerPlayer.winLoseBet > 0) {
            //winner.win(winnerPlayer);
            //获取玩家身上金币
            let doGames = this.inGameSeatEntity();//参与此牌局玩家
            for (let entity of doGames) {//全部归池
                entity.setBetState(false)//隐藏
                entity.guiChiToEntity(winner);
                entity.hideOpTimeState()
                entity.roundOver();
            }

            //获取池金币
            for (let i = 0; i < pools.length; i++) {
                let pool = pools[i];
                sidePool.recycleOneSidePot(i);
                winner.obtainBetNoFlyAction(pool.target,pool.totalBet,()=>{
                })
            }

            TableHelp.delay(this.dealerNode,()=>{

                let myself = this.getEntityServerID(this.selfServerSeatID);
                let type = winnerPlayer.maxCardInfo ? winnerPlayer.maxCardInfo.maxCardsType:null;
                winner.showWinAnim(type,()=>{
                    if (winner.isMySelf && !winner.isFold()
                    && myself &&  myself.isPlayingGame()) {
                        TexasSound.bipaiwin();
                    }
                    winner.flyGameLabAction();
                })

               
                if (!winner.isMySelf && myself && !myself.isFold()
                && myself.isPlayingGame()) {
                    TexasSound.bipailose();
                }
            },1)
        }
    }

    //玩家动作中
    protected playerDoAction(action:TexasProto.Texas.INextAction,protoData?:TexasProto.Texas.GameInfo){
        let tkplayerid = 0;
        if (action && action.playerAction) {
            tkplayerid = action.playerAction.playerId
        }
        if (protoData != undefined) {
            this.stopAllAction();
            this.setDealer(protoData.banker);//设置庄家
            this.gameTableInfo(protoData);
            let seatEntity = this.inGameSeatEntity();
            for (let seat of seatEntity) {
                seat.beginGame(protoData,tkplayerid);
            }
            this.showMaxCardPattern(protoData);
            //更新金币显示
            this.refreshGoldState(protoData);
        }
        if (action && action.playerAction) {
            this.playerNextAction(action.playerAction);
        }
        cc.log('-----------------玩家动作中');
    }

    protected showMaxCardPattern(protoData?:TexasProto.Texas.GameInfo){
        if (protoData.publicCards.length >= 3) {
            if (protoData.nextAction != undefined) {
                for (let player of protoData.players) {
                    if (player.playerId == ModelData.instance.roleData.id) {
                        this.updateMyMaxCardType(player.maxCardInfo);//最大牌型
                        break;
                    }
                }
            }
        }
    }

    //玩家发牌中
    protected dealCardsToPlayer(action:TexasProto.Texas.INextAction,protoData:TexasProto.Texas.GameInfo){
        if (protoData != undefined) {
            this.setDealer(protoData.banker);//设置庄家
            //先确定大小盲
            this.dealCardSetting(protoData);
            this.dealCardsAction();
            cc.log('-----------------玩家发牌中');
        }
    }



    //发牌开始之前
    protected dealCardSetting(data:TexasProto.Texas.IGameInfo){
        //大小盲确定,以及下注动画
        let seatEntity = this.inGameSeatEntity();
        for (let seat of seatEntity) {
            seat.updateOperatorState(data);
        }
    }

    //更新站起或者离开玩家的信息
    protected refreshGoldState(proto:TexasProto.Texas.GameInfo){
        //1.获取需要显示的玩家数据
        let players:TexasProto.Texas.GameInfo.IPosInfo[] = [];
        for (let info of proto.posInfo) {
            let isPush = true;
            for (let p of proto.players) {
                if (info.pos == p.playerPos 
                    && p.state == Define.PlayerState.Fighting) {
                        isPush = false;
                        break;
                }
            }
            
            if (isPush) {
                if (info.bet != undefined
                    && info.bet > 0) {
                    players.push(info);
                }
            }
        }

        //更新显示
        for (let info of players) {
            let entity = this.getEntityServerID(info.pos);
            if (entity) {
                entity.showBet(info.bet);
                entity.setBetState(true);
            }
        }
    }

    protected stopAllAction(){
        this.dealerNode.stopAllActions();
        this.viewBase.tableRoot.stopAllActions();
        this.viewBase.addBet.stopAllActions();
    }

    protected gameTableInfo(protoData:TexasProto.Texas.GameInfo){
        this.commonPokers.showImmediately(this.boardData.cards)
        this.refreshPot(protoData.pot);
        this.viewBase.updateSidePot(protoData.sidePots);
    }

    //更新总池
    protected refreshPot(pot:number){
        if (pot != undefined && pot > 0) {
            this.viewBase.setPotNumb(pot);//大于零才显示
        }
    }

    //设置玩家状态
    protected setPlayerAction(seat:number,func:Function){
        let entity = this.getEntityServerID(seat);
        if (entity) {
            func(entity);
        }
    }

    protected setPlayerActionPlayerID(playerID:number,func:Function){
        let entity = this.getEntityByPlayerID(playerID);
        if (entity) {
            func(entity);
        }
    }
    //可执行的动作
    onActionBroadCast(protoData:TexasProto.Texas.ActionBroadcast){
        super.onActionBroadCast(protoData);
        //设置上一个玩家状态
        let entity = this.getEntityServerID(protoData.playerPos);
        if (entity) {
            entity.previousSeatAction(protoData.currentAction,protoData.nextAction);
        }
        //上个玩家执行动作
        this.previousSeatAction(protoData.currentAction,protoData.playerPos);

        this.doNextAction(protoData.nextAction);

        this.refreshPot(protoData.pot);
    }

    onNextActionData(action:TexasProto.Texas.INextAction){
        super.onNextActionData(action);
        this.doNextAction(action);
    }

    playerEnterRoom(){
        this.refreshSeatVisible();
    }

    showAddBetWindow(){
        this.addBetCallBack(null,true);
    }

    //处理 nextAction
    protected doNextAction(action:TexasProto.Texas.INextAction){

        if (action != undefined) {
            let state = action.state;
            let func = this.stateFunc[state];
            if (func) {
                func(action);
            }else{
                cc.log('未处理的状态',state);
            }
            this.playersWinRate(action.players);
        }
    }

    //胜率
    protected playersWinRate(players:TexasProto.Texas.NextAction.IPlayer[]){
        if (Define.isDebugMode) {
            for (let data of players) {
                let entity = this.getEntityServerID(data.pos);
                if (data) {
                    let des = '胜率:' + data.winRate;
                    entity.setDes(des);
                    entity.setServerActive(true);
                }
               
            }
        }
    }

    //更新我方最大牌型
    protected updateMyMaxCardType(maxCardInfo:TexasProto.Texas.IMaxCardInfo){
        if (maxCardInfo == undefined) {
            return;
        }
        if (this.selfServerSeatID != 0) {//更新牌型
            let e = this.getEntityServerID(this.selfServerSeatID);
            let data = this.getPlayerSeatData();
            if (data && data.state != Define.PlayerState.GiveUp) {
                e.updateMyMaxCardType(maxCardInfo);
            }else{//更新牌型
                this.viewBase.setPatternMask(true);
                e.foldUpdateMaxCardType(maxCardInfo);
                this.showCardsType(maxCardInfo.maxCardsType);
            }

            //如果胜利了则直接隐藏即可,防止服务器时间重叠引发bug
            if (e && e.isStartMove) {
                cc.log('-->>>>>startMove');
                this.showPlayerCard(true);
                this.showTypeNode(false);
            }
        }
    }

    //玩家执行动作
    playerNextAction(nextAction:TexasProto.Texas.INextPlayerAction){
        if (nextAction != undefined) {
            let entity = this.getEntityByPlayerID(nextAction.playerId);
            if (entity) {
                entity.presentSeatAction(nextAction);
            }
            this.updateAutoSetting(nextAction);
        }
    }

    //更新座位的状态显示
    protected refreshSeatVisible(){
        if (this.selfServerSeatID == 0) {//自己离开
            for (let seat of this.seatEntityBase) {
                let viewID = this.getViewID(seat.serverSeatID);
                let seatNode = this.seatNode[viewID];
                seatNode.active = !seat.isSeat;
            }
        }else{//自己坐下
            // for (let seat of this.seatNode) {
            //     seat.active = false;
            // }

            for (let seat of this.seatEntityBase) {
                let viewID = this.getViewID(seat.serverSeatID);
                let seatNode = this.seatNode[viewID];
                seatNode.active = !seat.isSeat;
            }
        }
        this.checkSeekPlayers();
    }

    //更新边池
    updateSidePot(sidePots:TexasProto.Texas.ISidePot[]){
        //每轮结束归池
        this.roundOver();
        if (sidePots != undefined
            && sidePots.length > 0) {
            this.viewBase.updateSidePot(sidePots);
        }else{//没有就显示总池即可
            this.viewBase.updateSidePot([{totalBet:this.boardData.pot}]);//只有一个
        }
        super.resetMount();
    }

    //亮牌
    protected lightYourHands(players:TexasProto.Texas.GameSettlement.IPlayer[]){
        for (let player of players) {
            if (player.cards.length > 0) {
                let entity = this.getEntityByPlayerID(player.playerId);
                if (entity) {
                    entity.showEndHands(player.cards,player.maxCardInfo.maxCardsType);
                }
            }
        }
    }

    protected gameOverBefor(settlement:TexasProto.Texas.IGameSettlement){
        if (settlement != undefined) {
            //所有归池
            this.emit(Define.refreshUI,null);
            //更新主池
            this.viewBase.setPotNumb(settlement.totalBet);
        }
    }

    //游戏本局结束
    protected gameOver(data:TexasProto.Texas.IGameSettlement){
        cc.log('--------------------游戏结束------------------------');
        this.gameOverBefor(data)
    }

    //获取最大牌型
    private maxPattern(id:number,ps:TexasProto.Texas.IGameSettlement):TexasProto.Texas.IMaxCardInfo{
        for (let player of ps.players) {
            if (player.playerId == id) {
                return player.maxCardInfo;
            }
        }
        return null;
    }

    //大池中最大的
    private maxPlayerInBigSide(settlment:TexasProto.Texas.IGameSettlement,isFold?:boolean):TableData.IWinnerPlayer[]{
        let winner = [];
        for (let player of settlment.players) {
            let condition = isFold ? (player.obtainChips > 0) : (player.winLoseBet >= 0);
            if (condition) {
                let data = {
                    id:player.playerId,
                    bet:0,
                    winLoseBet:player.winLoseBet,
                    obtainChips:player.obtainChips,
                    feeGold:player.feeGold
                }
                winner.push(data);
            }
        }
        return winner;
    }

    //每轮结束执行
    protected roundOver(){
        for (let st of this.seatEntityBase) {
            st.roundOver();
        }
        //归池完成之后刷新玩家状态
        if (!this.commonData.isSettle) {
            TableHelp.delay(this.viewBase.mainNode,()=>{
                this.refreshSitState();
                this.refreshPlayerSeatUI();
            },Define.rounOverRefresh)
        }
    }

    //更新座位缓存状态
    protected refreshSitState(){
        //重置
        let sitData = this.boardData.sitRole.concat([]);
        for (let sit of sitData) {
            if (sit.state == Define.SitState.Leave) {
                let id = <number>sit.data;
                this.leaveTable(id);
            }else if (sit.state == Define.SitState.SitDown) {
                TexasSound.playSeat()
                let data = <TableData.SeatPlayerData>sit.data;
                let entity = this.getEntityServerID(data.player_pos)
                if (entity) {
                    entity.reset();
                    entity.seatData = data;
                }
                this.modeBase.pushSeatInfo(data);
                this.playerSitDownSeatID(data.player_pos);//座到新的位置
            }else if (sit.state == Define.SitState.Stand) {
                let id = <number>sit.data;
                this.roleStandUp(id);
            }else if (sit.state == Define.SitState.enterRoom) {
                let data = <TableData.SeatPlayerData>sit.data;
                let entity = this.getEntityServerID(data.player_pos)
                if (entity) {
                    entity.reset();
                    entity.seatData = data;
                    super.playerSitDownSeatID(data.player_pos);
                    this.playerEnterRoom();
                }
            }
        }
        this.boardData.sitRole = [];//清空状态
    }

    //处理边池动画
    private handleSidePotAction(sidePot:TexasProto.Texas.ISidePot,settlement:TexasProto.Texas.IGameSettlement){
        if (sidePot == null) {
            this.dealerNode.stopAllActions();
            let winners = this.maxPlayerInBigSide(settlement);
            this.doSidePotAction(winners,settlement,0);
        }else{
            this.doSidePotAction(sidePot.players,settlement,this.commonData.sidePotIndex);
        }
    }


    //最大玩家牌型
    private maxWinnerPattern(winners:TableData.IWinnerPlayer[],settlement:TexasProto.Texas.IGameSettlement):TableData.IWinnerPlayer{
        let patterns:TableData.IWinnerPlayer[] = [];
        //设置赢家信息
        for (let winner of winners) {
            if (winner.obtainChips > 0) {//有从池里面获取
                let pattern = this.maxPattern(winner.id,settlement)
                winner.maxCardInfo = pattern;
                patterns.push(winner);
            }
        }
        //找出最大牌型
        let maxPattern:TableData.IWinnerPlayer = null;
        for (let pt of patterns) {
            if (!maxPattern) {
                maxPattern = pt;
            }
            if (pt.maxCardInfo) {
                if (pt.maxCardInfo.maxCardsType > maxPattern.maxCardInfo.maxCardsType) {
                    maxPattern = pt;
                }
            }
        }
        return maxPattern;
    }

    //处理每个边池 sID 筹码ID
    private doSidePotAction(winners:TableData.IWinnerPlayer[],settlement:TexasProto.Texas.IGameSettlement,poolIndex:number){
        if (winners.length == 0) {
            return;
        }
        
        let doGames = this.inGameSeatEntity();//参与此牌局玩家
        let endByFold = settlement.endByFold;//是否是弃牌结束
        for (let entity of doGames) {
            entity.startHandlSidePot(endByFold);
        }
        let maxPattern = this.maxWinnerPattern(winners,settlement);//最大玩家
        if (maxPattern) {
            let entity = this.getEntityByPlayerID(maxPattern.id);
            if (entity) {
                if (!endByFold) {
                    if (maxPattern.maxCardInfo) {
                        entity.showMaxPattern(maxPattern.maxCardInfo);//显示最大牌型
                    }
                }
            }
    
            if (!endByFold) {
                //显示最大牌
                if (maxPattern.maxCardInfo) {
                    this.viewBase.showMaxCards(maxPattern.maxCardInfo.maxCards.length > 0);
                    this.viewBase.setMaxCardsTip(maxPattern.maxCardInfo);
                }
            }
        }

        //2.飞筹码,飞往多个
        let sidePool = this.viewBase.sidePool;
        for (let player of winners) {
            let entity = this.getEntityByPlayerID(player.id);
            if (entity) {
                if (player.obtainChips > 0) {//赢取筹码
                    entity.win(player);//赢家
                    let pool = sidePool.getPoolData(poolIndex);
                    cc.log('--------------->>>>>>边池处理',poolIndex);
                    if (pool) {
                        sidePool.recycleOneSidePot(poolIndex);
                        let chips = TableHelp.getRightMount(player.obtainChips);
                        entity.obtainBet(pool.target,chips);
                        // entity.showWinAnim(player.maxCardInfo,()=>{
                        //     //在边池位置产生筹码并马上飞到玩家位置
                        //     sidePool.recycleOneSidePot(poolIndex);
                        //     let chips = TableHelp.getRightMount(player.obtainChips);
                        //     entity.obtainBet(pool.target,chips);
                        // });
                    }
                }else{
                    entity.lose(player);
                }
            }
        }
        if (!endByFold) {
            this.viewBase.setHandState(false);
        }
        this.commonData.sidePotIndex++
    }

    playGameOverSound(winner:SeatEntityBase){
        if (winner.isMySelf) {//是我自己
            TexasSound.bipaiwin();
        }else{
            let myEntity = this.getEntityServerID(this.selfServerSeatID);
            if (myEntity) {
                if (myEntity.isPlayingGame()) {
                    TexasSound.bipailose();
                }
            }
        }
    }

    //上一个玩家执行动作
    previousSeatAction(action:TexasProto.Texas.IPlayerAction,seat:number){
        if (action.decision == Define.TableSeatAction.Fold) {
            if (this.selfServerSeatID == seat) {
                this.viewBase.isHandsBlack(true);
                this.viewBase.setPatternMask(true);
                this.emit(Define.refreshUI,null);//我弃牌
            }
        }else if (action.decision == Define.TableSeatAction.All_in) {
            if (this.selfServerSeatID == seat){
                this.emit(Define.refreshUI,null);//我弃牌
            }
        }
    }


    //当前玩家执行动作
    presentSeatAction(action:TexasProto.Texas.INextPlayerAction,prevMount:number){
    
    }

    //更新自动设置
    protected updateAutoSetting(nextAction:TexasProto.Texas.INextPlayerAction){
        if (nextAction == undefined) {//没有下个执行
            this.emit(Define.refreshUI,null);
            return;
        }
        let isPlaying = this.isSelfPlaying()
        if ( isPlaying  ) {//我已经全压无需显示
            let data = this.findSeatInfoBySeatID(this.selfServerSeatID);
            if (data
                && data.chips == 0) {//没有余额 可操作
                    this.emit(Define.refreshUI,null);
                return;
            }
        }
        let isRole = this.isRole(nextAction.playerId)
        if (isRole) {//是我方执行
            //1.是否有自动操作
            let myData = this.getPlayerSeatData();
            this.settingData.actionData = nextAction;
            this.settingData.decision_allowed = nextAction.decisionAllowed;
            this.settingData.chips = myData.chips;
            if (this.settingData.autoCheck != undefined &&
                this.settingData.autoCheck == TableData.AutoSetting.None) {//没有自动操作
                this.settingData.isMyRound = true;
            }else{//有自动操作
                // this.settingData.mount = this.commonData.maxBet - myData.bet;//新的跟注
                // if(this.settingData.autoCheck != TableData.AutoSetting.Chek_Pass
                //     && this.settingData.autoCheck != TableData.AutoSetting.Any_Call
                //     && this.settingData.mount > 0){//有更新
                //     this.settingData.isMyRound = true;
                // }else{//执行自动操作
                //     this.autoHandleOperator();//我执行自动操作
                // }

                let callBet = this.commonData.maxBet - myData.bet;//新的跟注
                let old = this.settingData.mount;
                this.settingData.mount = callBet
                if (callBet > old
                    && this.settingData.autoCheck == TableData.AutoSetting.Auto_Check) {
                        this.settingData.isMyRound = true;
                }else{
                    this.autoHandleOperator();
                }

                this.settingData.autoCheck = TableData.AutoSetting.None;//取消选定
            }
            this.settingData.mount = TableHelp.getRightMount(nextAction.callBet) || 0;
            this.emit(Define.refreshUI,this.settingData);
        }else{//不是我方操作
            isPlaying = this.isSelfPlaying()
            if (isPlaying) {
                this.settingData.isMyRound = false
                let myData = this.getPlayerSeatData()
                this.settingData.chips = myData.chips;
                if (myData) {
                    if (myData.bet >= this.commonData.maxBet) {//我的下注额比之前大
                        this.settingData.mount = 0;
                    }else{
                        let old = this.settingData.mount;
                        this.settingData.mount = this.commonData.maxBet - myData.bet;
                        if (this.settingData.mount > old) {
                            this.settingData.autoCheck = TableData.AutoSetting.None;//取消选定
                        }
                    }
                    this.emit(Define.refreshUI,this.settingData);//更新我方显示
                }
            }else{
                this.emit(Define.refreshUI,null);
            }
        }
    }

    //自动处理
    protected autoHandleOperator(){
        let autoCheck = this.settingData.autoCheck;
        if (autoCheck == TableData.AutoSetting.Chek_Pass) {//自动过或者弃牌
            //检查是否可以过
            let isCanOut = this.settingData.isOperator(Define.TableSeatAction.Check);
            if (isCanOut) {
                cc.log('--->>自动过牌');
                this.modeBase.send_playaction_request(Define.TableSeatAction.Check);
            }else{
                cc.log('--->>自动弃牌');
                this.modeBase.send_playaction_request(Define.TableSeatAction.Fold);
            }
        }

        //自动过牌
        if (autoCheck == TableData.AutoSetting.Auto_Check) {
            //-让牌
            let isCanCheck = this.settingData.isOperator(Define.TableSeatAction.Check)
            if (isCanCheck) {
                this.modeBase.send_playaction_request(Define.TableSeatAction.Check);
                cc.log('执行自动过牌操作');
            }else{
                this.modeBase.send_playaction_request(Define.TableSeatAction.Call);
                cc.log('执行跟牌操作');
            }
        }

        if (autoCheck == TableData.AutoSetting.Any_Call) {
            //跟任何注 判断余额 和 跟注额的大小,是否可以跟
            let data = this.findSeatInfoBySeatID(this.selfServerSeatID);
            if (data) {
                let isCall = this.settingData.isOperator(Define.TableSeatAction.Call)
                if (isCall) {//是否可以跟
                    cc.log('执行跟操作');
                    this.modeBase.send_playaction_request(Define.TableSeatAction.Call);
                }else{
                    let check = this.settingData.isOperator(Define.TableSeatAction.Check)
                    if (check) {
                        cc.log('执行让牌操作');
                        this.modeBase.send_playaction_request(Define.TableSeatAction.Check);
                    }else{
                        cc.log('自动执行All-IN操作');
                        this.modeBase.send_playaction_request(Define.TableSeatAction.All_in);
                    }
                }
            }
        }
    }

    //座位更改广播
    seatActionChangeBroadCast(protoData:TexasProto.Texas.SeatActionBroadcast){
        super.seatActionChangeBroadCast(protoData);
        for (let seat of protoData.seats) {
            let actionType = seat.type;
            let isRole = this.isRole(seat.playerId);
            if (actionType == Define.SeatAction.Stand) {//站起
                if (isRole) {
                    this.roleStandUp(seat.playerId);
                }else{
                    let player = this.findSeatInfo(seat.playerId)
                    let isInGame = this.isInGame(player.state);
                    cc.log('check-->>',isInGame,super.isInToCheckState())
                    if (super.isInToCheckState() && isInGame) {
                        
                    }else{
                        this.roleStandUp(seat.playerId);
                    }
                }
            }else if(actionType == Define.SeatAction.Seat) {//坐下
                if (isRole) {
                    TexasSound.playSeat()
                    this.playerSitDownSeatID(seat.seat);//座到新的位置
                    this.selfServerSeatID = seat.seat;
                    this.selfSeatDown(seat.seat);//座位旋转
                    if (this.boardData.gameState == Define.NextAction.Player_Actions) {
                        this.setDealer(this.boardData.banker);
                    }
                }else{
                
                }
            }else if (actionType == Define.SeatAction.Remain) {
                //玩家余额更新
                let entity = this.getEntityServerID(seat.seat);
                if (entity) {
                    let seatData = this.findSeatInfoBySeatID(seat.seat);
                    if (seatData) {
                        let oldChips = seatData.chips;
                        seatData.chips = seat.num;
                        if (Math.abs(oldChips - seat.num) >= 0.1) {
                            entity.updateEntityChips(oldChips);                   
                        }
                    }
                }
            }
        }

        // for (let id of protoData.playerId) {
        //     let actionType = protoData.action.type;
        //     let isRole = this.isRole(id);
        //     if (actionType == Define.SeatAction.Stand) {//站起
        //         if (isRole) {
        //             this.roleStandUp(id);
        //         }else{
        //             let player = this.findSeatInfo(id)
        //             let isInGame = this.isInGame(player.state);
        //             cc.log('check-->>',isInGame,super.isInToCheckState())
        //             if (super.isInToCheckState() && isInGame) {
                        
        //             }else{
        //                 this.roleStandUp(id);
        //             }
        //         }
        //     }else if(actionType == Define.SeatAction.Seat) {//坐下
        //         if (isRole) {
        //             TexasSound.playSeat()
        //             this.playerSitDownSeatID(protoData.action.seat);//座到新的位置
        //             this.selfServerSeatID = protoData.action.seat;
        //             this.selfSeatDown(protoData.action.seat);//座位旋转
        //             if (this.boardData.gameState == Define.NextAction.Player_Actions) {
        //                 this.setDealer(this.boardData.banker);
        //             }
        //         }else{
     
        //         }
        //     }
        // }

        this.refreshSeatVisible();
    }

    private roleStandUp(id:number){
        cc.log('-->>>玩家站起了',id);
        let seatData = this.findSeatInfo(id)
        if (seatData) {
            seatData.state = Define.PlayerState.Look_1;
            this.playerStandUpSeatID(seatData.player_pos);
            this.modeBase.removeSeatInfo(id);
        }
    }

    setDealer(seatID:number){
        let viewID = this.getViewID(seatID);
        if (viewID == -1) {
            return;
        }
        let isAnim = false;
        if (this.viewBase.dealer.active) {
            isAnim = true;
        }
        let seatInfo = this.seatInfo[viewID];

        if (seatInfo) {
            let endPos = seatInfo.dealer;
            let node = this.viewBase.dealer;
            node.stopAllActions();
            node.active = true;
            if (isAnim) {
                TableHelp.moveToAction(node,endPos,0.6);
            }else{
                node.position = endPos;
            }
        }
    }

    dealerState(isShow:boolean){
        this.viewBase.dealer.active = isShow;
    }

    throwCardsAction(){
        this.viewBase.throwCardsAction();
    }

    //检测寻找玩家
    checkSeekPlayers(){
        if (this.modeBase.seatData) {
            if (this.modeBase.seatData.length >= this.commonData.minJoinPeople) {
                EventManager.instance.dispatch('update_seek_player',0,0)
            }else{
                EventManager.instance.dispatch('update_seek_player',this.modeBase.seatData.length,this.commonData.minJoinPeople)
            }
        }else{
            EventManager.instance.dispatch('update_seek_player',0,0)
        }
    }

    //发牌 D为中心 顺时针发牌
    dealCardsAction(){
        let doActions = this.inGameSeatEntity(true);//参与游戏中的entity
        for (let ac of doActions) {
            ac.beginDealCards();//开始发牌
        }
        this.viewBase.beginDealCards();

        this.viewBase.dealerNode.stopAllActions();
        let index = 0;
        let count = doActions.length
        let cardIndex = 0;
        TableHelp.schedule(this.viewBase.dealerNode,()=>{
            if (index == count) {
                index = 0;
                if (cardIndex == 0) {
                    cardIndex = 1;
                }else{
                    this.viewBase.dealerNode.stopAllActions();
                    TableHelp.delay(this.viewBase.dealerNode,()=>{
                        this.viewBase.dealOverCards(()=>{
                            let entity = this.getEntityServerID(this.selfServerSeatID);
                            if (entity) {
                                entity.updateMyPatterner();
                            }
                        });
                    },0.4)
                    return;
                }
            }
            let present = doActions[index];
            if (present) {
                if (present.isMySelf) {
                    let data = present.seatData;
                    if (data) {
                        this.viewBase.dealCardsMySelf(cardIndex,data.cards);
                    }
                }else{
                    present.dealCards(this.viewBase.dealerNode,cardIndex);
                }
            }
            index++;
        },0.08);
    }

    reset(){
        super.reset();
        this.viewBase.reset();
        this.stopAllAction()
        this.emit(Define.refreshUI,null);
        //重置座位
        if (this.seatEntityBase) {
            for (let seatEntity of this.seatEntityBase) {
                seatEntity.reset();
                seatEntity.hideCheckGold();//金币独立显示
            } 
        }
        this.refreshSeatVisible();
    }

    leaveTable(playerID:number){
        if (this.isRole(playerID)) {

        }else{
            this.setPlayerActionPlayerID(playerID,(e:SeatEntityBase)=>{
                if (e.seatData) {
                    this.playerStandUpSeatID(e.seatData.player_pos)
                }
                e.leaveGame(playerID);
            })
        }

        super.leaveTable(playerID);
    }

    private gameOverCountdown(time:number){
        this.viewBase.addBet.stopAllActions();
        if (time <= 0) {//小于零无需弹框
            //取消弹框
            this.viewBase.isShowCountDown(false)
            this.viewBase.addBet.stopAllActions();
            return;
        }
        this.viewBase.addBet.stopAllActions();
        this.viewBase.isShowCountDown(true)
        this.viewBase.updateCountDwon(time);
        //离开检测
        this.checkLeaveGame();
        
        TableHelp.schedule(this.viewBase.addBet,()=>{
            time--;
            if (time <= 0) {
                this.viewBase.isShowCountDown(false)
                this.viewBase.addBet.stopAllActions();
            }else{
                this.viewBase.updateCountDwon(time);
            }
        },1)
    }

    private checkLeaveGame(){
        if (ModelData.instance.tableCommonData.autoLeaveWhenGameEnd) {
            this.ReqPlayerAction(Define.SeatAction.Leave)
        }
    }


    //清理工作
    clear(){
        this.reset();
        this.viewBase.clear();
        for (let et of this.seatEntityBase) {
            et.clear();
        }
    }

    //推出牌局
    exitTable(){
        super.exitTable();
        this.clear();
        //ModuleManager.instance.destroyModule('TexasPokerTable');
        SceneManager.gotoHallOrClubHall("TabelExit");
    }


}
